import {EventEmitter, Injectable, TemplateRef} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {ActivationStart, Router} from '@angular/router';

export interface IconfirmModalSettings {
    modalHeader: string,
    modalBody: string,
    buttonSubmit: string,
    buttonClose: string;
}

@Injectable({
    providedIn: 'root',
})
export class ModalService {

    public confirmModal: IconfirmModalSettings;

    public confirmModalTemplate: TemplateRef<any>;

    public modalCount = 0;

    public emitOnClose: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        private modalService: NgbModal,
        private router: Router,
    ) {
    }

    public openTemplateModal(content: TemplateRef<any>, sizeModal = 'lg', closeEsc: boolean = true): NgbModalRef {
        if (!['sm', 'pin', 'lg', 'xl'].includes(sizeModal)) {
            console.error('INVALID SIZE MODAL');
        }

        const modal = this.modalService.open(content, {
            ariaLabelledBy: 'modal-basic-title',
            windowClass: 'modal-z-window-fix',
            modalDialogClass: 'modal-z-dialog-fix',
            size: sizeModal,
            backdrop: 'static',
            keyboard: closeEsc,
        });

        this.router.events.subscribe(event => {
            if (event instanceof ActivationStart) {
                modal.close();
            }
        });

        modal.shown.subscribe(() => {
            const backdrop = document.querySelectorAll('.modal-backdrop')[this.modalCount];
            const backdropStyle = document.createAttribute('style');
            backdropStyle.value = 'z-index: ' + (1055 + (5 * this.modalCount)).toString();
            backdrop.attributes.setNamedItem(backdropStyle);

            const dialog = document.querySelectorAll('.modal')[this.modalCount];
            const dialogStyle = document.createAttribute('style');
            dialogStyle.value = 'z-index: ' + (1060 + (5 * this.modalCount)).toString();
            dialog.attributes.setNamedItem(dialogStyle);

            this.modalCount += 1;
        });

        modal.result.then(
            (result) => {
                this.modalCount -= 1;
                this.emitOnClose.emit();
                if (this.modalCount < 0) {
                    this.modalCount = 0;
                }
            },
            (reason) => {
                this.modalCount -= 1;
                this.emitOnClose.emit();
                if (this.modalCount < 0) {
                    this.modalCount = 0;
                }
            },
        );
        return modal;
    }

    public createFromSettings(settings): NgbModalRef {
        this.confirmModal = settings;
        return this.openTemplateModal(this.confirmModalTemplate, 'sm');
    }
}
